export default __webpack_public_path__ + "static/media/WhatsApp Image 2026-01-14 at 6.27.29 PM.9052b362.jpeg";